import React from 'react'

import { AcornsIcon } from '@acorns/icons'
import { Heading } from '@acorns/web-components'
import styled from 'styled-components'

import useWindowDimensions from 'hooks/useWindowDimensions'
import { style } from 'theme'

import { StyledBody, StyledCard, StyledCloseAccountButton } from '../components'
import { MergedProps } from './index'

const BodyContainer = styled.div`
  padding-bottom: 50px;
  @media screen and (max-width: ${style(
      (theme) => theme.breakpoints.sm - 1,
    )}px) {
    height: auto;
    min-height: 50%;
    align-self: center;
    padding-top: 50px;
  }
`

const ButtonContainer = styled.div`
  border-top: 1px solid rgb(245, 245, 245);

  @media screen and (max-width: ${style(
      (theme) => theme.breakpoints.sm - 1,
    )}px) {
    border-top: none;
    position: relative;
    width: 100%;
  }
`

const Footnote = styled.div`
  background-color: ${style((theme) => theme.colors.ivory)};
  border-radius: ${style((theme) => theme.styles.borderRadius)};
  font-size: 12px;
  font-weight: normal;
  height: 56px;
  letter-spacing: 0px;
  line-height: 16px;
  text-align: center;
  padding: 20px;
  max-width: 460px;
  margin: 0 auto;
  color: ${style((theme) => theme.colors.stone)};
  @media screen and (max-width: ${style(
      (theme) => theme.breakpoints.sm - 1,
    )}px) {
    height: 72px;
  }
`

const WVCard = styled(StyledCard)<{ innerHeight?: number }>`
  display: flex;
  justify-content: space-between;
  min-height: ${(props) => `${props.innerHeight}px`};
  &&& {
    border-radius: 0;
  }
`

const StyledButton = styled(StyledCloseAccountButton)`
  margin-top: 50px;
  @media screen and (max-width: ${style(
      (theme) => theme.breakpoints.sm - 1,
    )}px) {
    margin-top: auto;
  }
`
const StyledHeading = styled(Heading)`
  font-size: 22px !important;
  line-height: 30px;
  text-align: center;
  margin-bottom: 10px;
`

const Body = styled(StyledBody)`
  margin: 0 auto;
  max-width: 530px;
  padding-top: 10px;
  padding-bottom: 20px;
`
type LocalProps = {
  hasSpendBalance: boolean
  buttonText: string
}
type Props = MergedProps & LocalProps

export const ConfirmationScreen: React.FC<Props> = ({
  handleDone,
  hasSpendBalance,
  buttonText,
  isWebView,
}) => {
  const CardComponent = isWebView ? WVCard : StyledCard
  const { height } = useWindowDimensions()
  return (
    <>
      {hasSpendBalance ? (
        <CardComponent innerHeight={isWebView ? height : null}>
          <BodyContainer>
            <AcornsIcon
              icon={AcornsIcon.Icon.AcornsPending}
              width="104px"
              height="104px"
              style={{ display: 'block', margin: '0 auto' }}
            />

            <StyledHeading>Closure in progress</StyledHeading>
            <Body>
              We'll start transferring your money and let you know as soon as
              the account is closed. Transfers may take up to 3-6 business days
              to settle.
            </Body>

            <Footnote>
              Don't forget to update any automatically paid bills or direct
              deposits as well.
            </Footnote>
          </BodyContainer>
          <ButtonContainer>
            <StyledButton onClick={handleDone}>Done</StyledButton>
          </ButtonContainer>
        </CardComponent>
      ) : (
        <CardComponent innerHeight={isWebView ? height : null}>
          <BodyContainer>
            <AcornsIcon
              icon={AcornsIcon.Icon.AcornsPending}
              width="104px"
              height="104px"
              style={{ display: 'block', margin: '0 auto' }}
            />

            <StyledHeading>Closure in progress</StyledHeading>
            <StyledBody>
              We'll let you know as soon as the account is closed.
            </StyledBody>
            <Footnote>
              Don't forget to update any automatically paid bills or direct
              deposits as well.
            </Footnote>
          </BodyContainer>
          <StyledCloseAccountButton onClick={handleDone}>
            {buttonText}
          </StyledCloseAccountButton>
        </CardComponent>
      )}
    </>
  )
}
